import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Checkbox } from '@openx/components-core/lib/Checkbox/Checkbox';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { exportType } from '../../../../../AudienceForm/constants';
import { getExportTypeLabels } from '../../../../../AudienceForm/utils/getExportTypeLabels';

export function AudienceOptions({ type, exportTargets }: { type?: string; exportTargets?: string[] }) {
  const { t } = useTranslation();

  const exportTypeLabels = useMemo(() => getExportTypeLabels(t), [t]);
  const exportTargetsOptions = useMemo(() => {
    const output = [
      {
        field: 'cookie',
        label: t('Cookies'),
      },
      {
        field: 'device',
        label: t('MAIDs'),
      },
      {
        field: 'idl',
        label: t('RampID'),
      },
      {
        field: 'ctv',
        label: t('CTV'),
      },
    ];

    if (type !== exportType.BIDSTREAM_PLUS) {
      output.push(
        {
          field: 'ip',
          label: t('IP Address'),
        },
        {
          field: 'id5',
          label: t('ID5'),
        }
      );
    }

    return output;
  }, [type, t]);

  return (
    <FormSection divider title={t('Audience Options')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <Stack spacing={2}>
        <FieldDetails
          title={t('Match Type')}
          value={type ? exportTypeLabels[type] : t('Unknown')}
          dataTest="audience-options-match-type"
        />
        <Box>
          <Typography variant="overline">{t('Target Id Types')}</Typography>
          <Stack direction="row">
            {exportTargetsOptions.map(({ field, label }) => (
              <FormControlLabel
                key={field}
                control={<Checkbox checked={exportTargets?.includes(field)} disabled={true} />}
                label={label}
                data-test={`audience-options-target-${field}`}
              />
            ))}
          </Stack>
        </Box>
      </Stack>
    </FormSection>
  );
}
